import data from "../../../../../src/Avatar/Avatar.docs.json";
import { Avatar, Box } from '@primer/react';
import * as React from 'react';
export default {
  data,
  Avatar,
  Box,
  React
};